import React from "react";
import { X } from "lucide-react";
import { CollaboratorData } from "../../../../../interfaces/BusinessObject";
import UserByPhoneInput, { ResolvedUser } from "../../../../shared/UserByPhoneInput/UserByPhoneInput";
import "./styles/CollaboratorInput.css";

interface CollaboratorInputProps {
  value: CollaboratorData[];
  onChange: (collaborators: CollaboratorData[]) => void;
}

const CollaboratorInput: React.FC<CollaboratorInputProps> = ({ value, onChange }) => {
  const handleResolved = (user: ResolvedUser) => {
    onChange([
      ...value,
      {
        collaboratorPhone: user.phone,
        collaboratorId: user.userId,
        collaboratorName: user.userName,
      },
    ]);
  };

  const handleRemove = (phone: string) => {
    onChange(value.filter((c) => c.collaboratorPhone !== phone));
  };

  return (
    <div className="collab-input-root">
      <UserByPhoneInput
        resolved={null}
        onResolved={handleResolved}
        onCleared={() => {}}
        placeholder="10-digit phone number"
        excludePhones={value.map((c) => c.collaboratorPhone)}
        duplicateMessage="This number is already added."
      />

      {value.length > 0 && (
        <div className="collab-chips">
          {value.map((collab) => (
            <span key={collab.collaboratorPhone} className="collab-chip">
              <span className="collab-chip-info">
                {collab.collaboratorName && (
                  <span className="collab-chip-name">{collab.collaboratorName}</span>
                )}
                <span className="collab-chip-phone">{collab.collaboratorPhone}</span>
              </span>
              <button
                type="button"
                className="collab-chip-remove"
                onClick={() => handleRemove(collab.collaboratorPhone)}
                aria-label={`Remove ${collab.collaboratorPhone}`}
              >
                <X size={12} />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default CollaboratorInput;
